<template lang="pug">
.vidSimple(:style="{width:w,height:h}" ref="wrapper")
    canvas.poster(ref="canvas" :width="cw" :height="ch" v-show="showPoster")
    video(
        :loop="loop"
        :autoplay="autoplay"
        :src="src"
        ref="vid"
        :muted="muted"
        :controls="controls"
    )
    
</template>

<script>
    // VidSimple(
    //     :src="this.basePath+this.datas[thiscCur]+'.mp4'"
    //     w=3840
    //     h=2160
    // )
import gsap from 'gsap'
import ResizeService from '@/services/ResizeService'
//import VidFade from './vidUtil/VidFade'
export default {
    props:{
        src: String,
        width: {default: 2160},
        height: {default: 2160},
        loop: {default: true},
        autoplay: {type: Boolean,default: true},
        endCallBack: {default: null},
        vidProgress: {default: null},
        controls: {default: false},
        muted:{type: Boolean,default: true},
        showPoster:{type: Boolean,default: true},
    },
    data(){
        return{
            switching: false,
            loading: false,
            ctx: null,
            dpi: 1,
            cw: 1920,
            ch: 1080,
            ratW: 1,
            ratH: 1,//窗口尺寸与视频真实尺寸比值
        }
    },
    computed:{

        w(){
            return this.pxToRem(this.width)
        },
        h(){
            return this.pxToRem(this.height)
        }
    },
    watch:{
        src(){
            // console.log('old: ',this.src,',new: ', val)
            this.$refs.vid.pause()
            this.switching = true
            this.gThumb()
            gsap.set(this.$refs.canvas,{alpha:1})
            setTimeout(()=>{
                // console.log('timeout')
                this.$refs.vid.addEventListener('canplay', this.onCanplay)
                this.vidSrc = this.src
            },40)
        }
    },
    beforeMount(){
        this.dpi = window.devicePixelRatio
        this.vidSrc = this.src
    },
    mounted(){
        this.onEndedVid = this.onEndedVid.bind(this)
        this.onProgress = this.onProgress.bind(this)
        this.onCanplay = this.onCanplay.bind(this)
        this.onResize = this.onResize.bind(this)
        ResizeService.getInstance().add(this.onResize)
        this.ctx = this.$refs.canvas.getContext('2d')
        this.$refs.vid.addEventListener('ended', this.onEndedVid)
        if(this.vidProgress){
            this.$refs.vid.addEventListener('timeupdate', this.onProgress)
        }
    },
    beforeDestroy(){
        //this.vidFade.destroy()
        ResizeService.getInstance().remove(this.onResize)
    },
    methods:{
        onResize(){
            setTimeout(()=>{
                this.cw = window.getComputedStyle(this.$refs.wrapper).getPropertyValue('width').slice(0,-2) * this.dpi
                this.ch = window.getComputedStyle(this.$refs.wrapper).getPropertyValue('height').slice(0,-2) * this.dpi

            },300)
        },
        pxToRem(px){
            return `${px/14*0.5}rem`
        },
        onCanplay(){
            this.switching = false
            if(this.$refs.vid)this.$refs.vid.removeEventListener('canplay', this.onCanplay)
            this.ratW=this.width/this.$refs.vid.videoWidth
            this.ratH=this.height/this.$refs.vid.videoHeight
            gsap.set(this.$refs.canvas,{alpha:0})
        },
        onProgress(){
            if(this.$refs.vid)this.vidProgress(this.$refs.vid.currentTime/this.$refs.vid.duration)
        },
        onEndedVid(){
            if(this.endCallBack){
                this.endCallBack()
            }
        },
        replay(){
            this.stop()
            this.resume()
        },
        pause(){
            this.$refs.vid.pause()
        },
        resume(){
            this.$refs.vid.play()
        },
        stop(){
            this.$refs.vid.currentTime = 0
        },
        seek(n){
            if(n>=0&&n<this.$refs.vid.duration)this.$refs.vid.currentTime=n
        },
        seekoff(n){
            this.seek(this.$refs.vid.currentTime+n)
        },
        seekfactor(f){
            this.seek(this.$refs.vid.duration*f)
        },
        gThumb() {     
            //generate thumbnail URL data
            if(this.ctx){
                // const _w = this.width*this.width/1920
                const _w = this.width
                // const _h = this.height*this.height/1080
                const _h = this.height
                const _w1 = this.cw
                const _h1 = this.ch
                console.log('/////////////',_w,_h,_w1,_h1,this.dpi)
                this.ctx.drawImage(this.$refs.vid, 0, 0, _w, _h,0,0, _w1*this.ratW, _h1*this.ratH)
            }
        },
        currentTime(){
            return this.$refs.vid.currentTime
        },
        duration(){
            return this.$refs.vid.duration?this.$refs.vid.duration:0
        }

    }
}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.vidSimple
    position: relative
    video
        +full()
        object-fit: contain
    .poster
        +full()
        // opacity: 0

</style>
